!function($) {

    // Add custom JavasScript here
    // --------------------------
      
    //get message from iframe 
    console.log("debug");
    window.addEventListener('message', event => {
        var targetInput = $('input[name^="properties[Color]"]').first();
        if (event.origin.startsWith('https://www.lancopaints.com')) { 
            if(targetInput.length > 0) {
                targetInput.val(event.data);
                targetInput.attr('readonly', true);
                $("#pickerModal").modal("hide");
            }
        } else {
            return; 
        } 
    });
  
    // show modal on click input
    jQuery( document ).ready(function() {
      setTimeout(function(){ 
        var targetInput = jQuery('#openmodal');
        if(targetInput.length > 0) {
          targetInput.click(function() {
           jQuery('#pickerModal').modal('show');
  
          });
        } 
      }, 3000);
      var targetInput2 = jQuery('input[name^="properties[Color]"]').first();
      if(targetInput2.length > 0) {
        targetInput2.click(function() {
         jQuery('#pickerModal').modal('show');
  
        });
      } 
    });
  
    // add icon before input 
  
    jQuery( document ).ready(function() {
      var targetInput = jQuery('input[name^="properties[Color]"]').first();
      if(targetInput.length > 0) {
        targetInput.before( "<img id='openmodal' style='display: block;max-width: 58px;margin-bottom: 20px;' src='https://www.lancostore.com/wp-content/uploads/2017/07/circulo-cromatico-12-colores-100x100-1.jpg'>" );
      } 
    });
  
    // hide custom select color if last option is "Otro"
  
    jQuery( document ).ready(function() {
      var lastoption = jQuery('.swatch-element').last().find("input").val();
      var targetInputtohide = jQuery('input[name^="properties[Color]"]').first();
      var imagetohide = jQuery('#openmodal');
      console.log(lastoption);
      if( lastoption == "Otro") {
        targetInputtohide.css("display", "none");
        imagetohide.css("display", "none");
      }
  
      setTimeout(function(){ 
        var inputcurrentvalue = jQuery('input[name="option-1"]:checked').val();
        if(inputcurrentvalue == "Otro") {
          targetInputtohide.css("display", "block");
          imagetohide.css("display", "block");
        }
      }, 1000);
    });
  
  //
    
  
  
    // Document ready
    $(function() {
  
  
    });
  
  }(jQuery);